import styled from "styled-components";
import { device } from "../../../style/util/media-query";

export const StyledFooter = styled.footer`
  @media ${device.desktop} {
    margin-top: 5rem;
  }

  // GARENA FOOTER
  .garena-footer {
    position: relative;
    padding: 10px 0 50px;
    color: white;
    background: #101215;
    -webkit-font-smoothing: antialiased;

    a {
      text-decoration: none;
      display: inline-block;
    }

    .container {
      max-width: 1220px;
      width: 100%;
      margin: auto;
    }

    .copyrights {
      color: white;
      line-height: 1.4;
      text-align: center;
      padding: 0 5px;
    }

    @media screen and (max-width: 1000px) {
      padding: 50px 0;

      .container {
        max-width: 1000px;
        width: 100%;
      }

      .bottom {
        width: auto;
        display: block;
        margin: 0;
      }

      .logos {
        margin: 0 auto 20px;
      }

      .cnt {
        width: auto;
        text-align: center;
      }
    }
  }
`;
